import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="container">
      <h1>404</h1>
      <p>Oops! Page not found.</p>
      <Link to="/" className="back-btn">Go Back Home</Link>

      <style jsx>{`
        .container {
          height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          background-color: #1a1a1a;
          color: white;
          font-family: 'Arial', sans-serif;
          text-align: center;
          animation: fadeIn 1s ease-in-out;
        }

        h1 {
          font-size: 10rem;
          font-weight: bold;
          margin: 0;
          animation: bounceIn 1.5s infinite;
        }

        p {
          font-size: 1.5rem;
          margin-top: 20px;
          color: #f0f0f0;
          animation: fadeInUp 1.5s forwards;
        }

        .back-btn {
          display: inline-block;
          margin-top: 30px;
          padding: 10px 20px;
          font-size: 1.2rem;
          background-color: #e94e77;
          color: white;
          border: none;
          border-radius: 5px;
          cursor: pointer;
          text-decoration: none;
          transition: background-color 0.3s;
        }

        .back-btn:hover {
          background-color: #d4416b;
        }

        @keyframes fadeIn {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }

        @keyframes bounceIn {
          0% {
            transform: translateY(-200px);
            opacity: 0;
          }
          50% {
            transform: translateY(30px);
            opacity: 1;
          }
          100% {
            transform: translateY(0);
          }
        }

        @keyframes fadeInUp {
          0% {
            opacity: 0;
            transform: translateY(20px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default NotFound;
